// extracted by mini-css-extract-plugin
export default {"dropdown":"_2qsZ11qqx-qkAFk1MSYc5h"};